import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import Thermal from 'components/thermals/Thermal';
import PageWrapper from 'components/utils/PageWrapper';
import { DSM_TYPE_KEY } from 'constants/thermal';
import Thermals from 'pages/Thermals';
import dsmPlaceholder from '../images/dsm-unselected.png';

export const dsmRoutes = {
    path: '/dsm',
    element: (
        <PageWrapper titleId="dsm_title">
            <Thermals type={DSM_TYPE_KEY} key={DSM_TYPE_KEY} />
        </PageWrapper>
    ),
    children: [
        {
            index: true,
            element: <WrapperEmptyState imgSrc={dsmPlaceholder} page="Load Flex / DSM" noun="configuration" />,
        },
        {
            path: ':thermalId',
            element: <Thermal type={DSM_TYPE_KEY} />,
        },
    ],
};
